import axiosClient from "../common/axios/axiosConfig";
import { BuyDetailsInterface } from "../components/checkout/CheckoutCommon";
import { IUserData } from "../components/utils/getUserData";
import { showToast } from "../utils/showToast";
import axios from "axios";

interface executeRescheduleResponse {
	success: boolean;
	id: string;
	transactionError?: {
		data?: {
			type?: string;
		};
	};
}

const executeReschedule = async (
	scheduleId: string,
	checkoutId: string,
	personalData: IUserData,
	purchaseData: BuyDetailsInterface | undefined,
): Promise<executeRescheduleResponse | void> => {
	try {
		const response = await axiosClient.patch<executeRescheduleResponse>("/reagendar", {
			idAgendamento: scheduleId,
			idCheckout: checkoutId,
			dadosCartao: purchaseData,
			dadosPessoais: personalData,
			skipPayment: personalData.skipPayment,
		});
		if (!response.data.success) {
			if (response.data?.transactionError?.data?.type == "card_error") {
				showToast("error", {
					text: "Erro ao reagendar - verifique as informações do cartão",
					showConfirmButton: true,
					confirmButtonText: "OK",
				});
			} else {
				showToast("error", {
					text: "Não foi possível reagendar, tente novamente com outra data ou horário",
					showConfirmButton: true,
					confirmButtonText: "OK",
				});
			}
		}
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error) && error.response) {
			const data = error.response.data;
			const minCancelTime = data?.minCancelTime || JSON.parse(data?.message || '{}')?.minCancelTime;
			
			if (minCancelTime > 0) {
				showToast("error", {
					text: `O cancelamento para reagendar só é permitido com no mínimo ${minCancelTime} minutos de antecedência!`,
					showConfirmButton: true,
					confirmButtonText: "OK",
				});
				return;
			}
		}
		
		showToast("error", {
			text: "Tivemos um problema ao reagendar, tente novamente com outra data ou horário",
			showConfirmButton: true,
			confirmButtonText: "OK",
		});
	}
};

export default executeReschedule;
